// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"6c696e94","274":"8ca5e8a0","541":"91d6ca22","827":"bf9860f7"}[chunkId] + ".chunk.js";
};